export default {
  index: [
    {
      path: '/yhorder',
      component: resolve => require(['./yhorderIndex.vue'], resolve),
    }
  ]
}



// WEBPACK FOOTER //
// ./src/view/yh_order/_router.js